module.exports = __webpack_public_path__ + "img/payload.7a4a687c.svg";